import React from 'react';
import Cryptocurrency from '../assets/images/crr.jpg';
import Bicycle from '../assets/images/bicycle.jpg';
import GloryClothes from '../assets/images/gggg.jpg';
import Todo from '../assets/images/todo.jpg';

const Projects = () => {
  return (
    <div
      name="projects"
      className="md:h-screen w-full bg-[#0a192f] text-gray-300"
    >
      <div className="max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full">
        <div className="pb-8 text-center">
          <p className="text-4xl font-bold inline border-b-4 text-gray-300 border-blue-600 ">
            Projects
          </p>
          <p className=" py-6 ">Check out my projects</p>
        </div>
        <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-4">
          {/* container */}

          <div
            style={{ backgroundImage: `url(${Cryptocurrency})` }}
            className="shadow-lg shadow-[#040c16] group container rounded-md rounded-b-none flex justify-center items-center mx-auto content-div"
          >
            {/* hover1 */}
            <div className="opacity-0 group-hover:opacity-100">
              <span className="text-2xl font-bold text-white tracking-wider">
                Cryptocurrency Application
              </span>
              <div className="pt-8 text-center">
                <a href="https://crypto-tracker-vert-nine.vercel.app/">
                  <button className="text-center rounded-lg px-4 py3 m-2 bg-white text-gray-700 font-bold text-lg hover:bg-blue-600 hover:text-white hover:scale-110 duration-300">
                    Live
                  </button>
                </a>
                <a href="https://github.com/akinakgunes12/crypto-tracker">
                  <button className="text-center rounded-lg px-4 py3 m-2 bg-white text-gray-700 font-bold text-lg hover:bg-blue-600 hover:text-white hover:scale-110 duration-300">
                    GitHub
                  </button>
                </a>
              </div>
            </div>
          </div>
          <div
            style={{
              backgroundImage: `url(${GloryClothes})`,
            }}
            className="shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div"
          >
            {/* hover2 */}
            <div className="opacity-0 group-hover:opacity-100">
              <span className="text-2xl font-bold text-white tracking-wider">
                Glory Clothes Application
              </span>
              <div className="pt-8 text-center">
                <a href="https://glory-clothess.vercel.app/">
                  <button className="text-center rounded-lg px-4 py3 m-2 bg-white text-gray-700 font-bold text-lg hover:bg-blue-600 hover:text-white hover:scale-110 duration-300">
                    Live
                  </button>
                </a>
                <a href="https://github.com/akinakgunes12/glory-clothes">
                  <button className="text-center rounded-lg px-4 py3 m-2 bg-white text-gray-700 font-bold text-lg hover:bg-blue-600 hover:text-white hover:scale-110 duration-300">
                    GitHub
                  </button>
                </a>
              </div>
            </div>
          </div>
          <div
            style={{ backgroundImage: `url(${Bicycle})` }}
            className="shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div"
          >
            {/* hover3 */}
            <div className="opacity-0 group-hover:opacity-100">
              <span className="text-2xl font-bold text-white tracking-wider">
                Bicycle Application
              </span>
              <div className="pt-8 text-center">
                <a href="https://bicycle-project.vercel.app/">
                  <button className="text-center rounded-lg px-4 py3 m-2 bg-white text-gray-700 font-bold text-lg hover:bg-blue-600 hover:text-white hover:scale-110 duration-300">
                    Live
                  </button>
                </a>
                <a href="https://github.com/akinakgunes12/bicycle-project">
                  <button className="text-center rounded-lg px-4 py3 m-2 bg-white text-gray-700 font-bold text-lg hover:bg-blue-600 hover:text-white hover:scale-110 duration-300">
                    GitHub
                  </button>
                </a>
              </div>
            </div>
          </div>
          <div
            style={{
              backgroundImage: `url(${Todo})`,
            }}
            className="shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div "
          >
            {/* hover4 */}
            <div className="opacity-0 group-hover:opacity-100">
              <span className="text-2xl font-bold text-white tracking-wider">
                Todo Application
              </span>
              <div className="pt-8 text-center">
                <a href="https://todo-app-black-ten.vercel.app/">
                  <button className="text-center rounded-lg px-4 py3 m-2 bg-white text-gray-700 font-bold text-lg  hover:bg-blue-600 hover:text-white hover:scale-110 duration-300">
                    Live
                  </button>
                </a>
                <a href="https://github.com/akinakgunes12/todo-app">
                  <button className="text-center rounded-lg px-4 py3 m-2 bg-white text-gray-700 font-bold text-lg hover:bg-blue-600 hover:text-white hover:scale-110 duration-300">
                    GitHub
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
